module.exports = __webpack_public_path__ + "img/Slider Soldadora Maraga.28e402d0.png";